import { authFetch } from "@/api/authFetch"
import { API_BASE } from "@/config"

import type { LiveForHireMetrics } from "../types/forHireTypes"

export const getLiveForHireMetrics = async (
  period: "Daily" | "Weekly" | "Monthly",
): Promise<LiveForHireMetrics> => {
  const res = await authFetch(`${API_BASE}/forhire/live?period=${period}`)
  const data: LiveForHireMetrics = await res.json()
  return data
}
